export enum ExecutionStatus {
  SUCCESS = "Success",
  FAILURE = "Failure",
}
export const normalizeExecutionStatus = (
  name?: string
): ExecutionStatus | undefined => {
  const normalized = name?.trim().toLowerCase();

  return Object.values(ExecutionStatus).find(
    (status) => status.toLowerCase() === normalized
  );
};
